// Geometric Avatar Component for Ace Black
export default function GeometricAvatar({ size = 200, className = "" }) {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 200 200" 
      className={className}
      style={{ background: '#002FA7' }}
    >
      {/* Background */}
      <rect width="200" height="200" fill="#002FA7" />
      
      {/* Abstract geometric patterns */}
      {/* Large circle */}
      <circle cx="100" cy="85" r="50" fill="#FFFFFF" opacity="0.9" />
      
      {/* Triangular accent */}
      <polygon points="60,150 100,110 140,150" fill="#FFC107" />
      
      {/* Small decorative shapes */}
      <rect x="30" y="30" width="20" height="20" fill="#E53935" transform="rotate(45 40 40)" />
      <rect x="150" y="30" width="15" height="15" fill="#FFFFFF" opacity="0.5" transform="rotate(30 157.5 37.5)" />
      
      {/* Lines */}
      <line x1="20" y1="170" x2="80" y2="170" stroke="#FFFFFF" strokeWidth="3" opacity="0.6" />
      <line x1="120" y1="170" x2="180" y2="170" stroke="#FFFFFF" strokeWidth="3" opacity="0.6" />
      
      {/* Initials AB */}
      <text 
        x="100" 
        y="95" 
        textAnchor="middle" 
        fill="#002FA7" 
        fontSize="36" 
        fontWeight="900" 
        fontFamily="Outfit, sans-serif"
      >
        AB
      </text>
      
      {/* Decorative dots */}
      <circle cx="45" cy="120" r="5" fill="#FFFFFF" opacity="0.4" />
      <circle cx="155" cy="120" r="5" fill="#FFFFFF" opacity="0.4" />
      <circle cx="100" cy="180" r="4" fill="#FFC107" />
    </svg>
  );
}
